import { FieldsCollection } from "./FieldsCollection";

export class Applicant2SetupFieldsCollection extends FieldsCollection {
  constructor() {
    super();
    this.addTextField("setupFirstName", "First Name", 50);
    this.addTextField("setupLastName", "Last Name", 50);
    this.addTextField("setupEmailAddress", "E-mail", 100);
    this.addPicklistField("setupEmployentStatus", "Employment", [
      { text: "Employed", value: 778390000 },
      { text: "Self Employed", value: 778390001 },
      { text: "Home Maker", value: 778390002 },
      { text: "Retired", value: 778390003 },
      { text: "Not Employed", value: 778390004 },
    ]);
  }
}
